import { Component } from '@angular/core';

@Component({
    selector: 'app-header-full',
    templateUrl: './header-full.component.html',
    styleUrls: ['./header-full.component.sass']
})
export class HeaderFullComponent {}
